// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1zwSW","title":"InfoRow_title__1UeSy"};